<template>
  <v-card color="grey lighten-5" flat>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-flex xs12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="white--text"
          > {{ $t('Current-Card-Details') }} </v-toolbar-title
        >
        <v-spacer></v-spacer>

    
          <v-btn class="white--text" @click="goDetail(Current.Code)" flat>
            <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
            <v-icon right dark>create</v-icon>
          </v-btn>
  <v-btn class="white--text" @click="goToPersonelPage(Current.Code)" flat>
  <span class="hidden-sm-and-down"> {{ $t('Customer-Personnel') }} </span>
  <v-icon right dark>group</v-icon>
</v-btn>


      </v-toolbar>
    </v-flex>

    <v-layout row wrap>
      <v-flex pa-1 xs12 sm12 md6>
        <v-flex xs12 sm12 md12 style="padding-right: 2px">
          <v-card color="#1E88E5" class="white--text">
            <v-layout>
              <v-flex xs2 sm2 md1>
                <v-layout align-center="" justify-center="" fill-height="">
                  <v-icon color="white" large="">perm_identity</v-icon>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm10 md11>
                <v-card-title primary-title="">
                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            {{ $t("Title_label") }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Title }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Code') }} </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Code }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t("Authorized_label") }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Authorized }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Identitynumber_label') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.IdentityNumber }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{$t('Taxcenter_label') }} / {{ $t('No') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.TaxOffice }}/{{
                                Current.Invoice.TaxNumber
                              }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
              {{ $t('General-Information') }}
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-flex>

      <v-flex pa-1 xs12 sm12 md6>
        <v-flex xs12 sm12 md12 style="padding-right: 2px">
          <v-card color="#1E88E5" class="white--text">
            <v-layout>
              <v-flex xs2 sm2 md1>
                <v-layout align-center="" justify-center="" fill-height="">
                  <v-icon color="white" large="">info</v-icon>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm10 md11>
                <v-card-title primary-title="">
                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Phonenumber_label') }} 1 </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Phone1 }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Phonenumber_label') }} 2 </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Phone2 }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              Web
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md5>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Web }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Email_label') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md5>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Email }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t("Address_label") }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.Address }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Expense-Unit-VKN') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.SpendingUnitVKN }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

              
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
              {{ $t('Contact-Information') }}
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-card color="grey lighten-5" flat="">
      <v-layout row wrap>
        <v-flex xs12 pt-2 pb-2 pr-1 pl-1 sm12 md12>
          <v-card flat>
            <v-layout pa-2 row wrap>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="false"
                  v-model="date"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                ></tarihim>
              </v-flex>

              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="date2"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                ></tarihim>
              </v-flex>

              <v-flex align-end="" xs12 sm1 md1>
                <div v-if="load1">
                  <v-btn color="info" @click="Raporla()" fab small="" dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>

                <div v-if="!load1">
                  <v-progress-circular
                    indeterminate
                    :width="4"
                    color="blue"
                  ></v-progress-circular>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-layout row="" wrap>
          <v-flex pa-1 xs12 sm6 md4>
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">add_comment</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Toplambiletadet }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold">
                  {{  $t('Total-Ticket-Number') }}
                </span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#4CAF50" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Toplamfatbiletad }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold"
                  >{{ $t('Invoiced-Ticket-Number') }}</span
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#FF5252" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Faturaedilmemisbilet }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold">
                  {{ $t('Not-invoiced-Ticket-Number') }}</span
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </v-card>
</template>


<script>
import auth from "../../../api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },

      prevRoute: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      modal2: false,
      dateFormatted2: "",
      Current: {
        CompanyCode: "",
        Code: "",
        Title: "",
        Phone1: "",
        Phone2: "",
        Mobile: "",
        Web: "",
        Authorized: "",
        WarningNote: "",
        InfoNote: "",
        Invoice: {
          Address: "",
          PostCode: "",
          Province: "",
          Country: "",
          TaxNumber: "",
          TaxOffice: "",
          IdentityNumber: "",
        },
      },
      StartDate: null,
      EndDate: null,
      Faturaedilmemisbilet: 0,
      Toplamfatbiletad: 0,
      Toplambiletadet: 0,
      load: false,
      load1: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",

      dictionary: {
        custom: {
          tarihsecbas: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsecbit: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  methods: {
goToPersonelPage(code) {
  this.$router.push({ name: 'cari-personel', params: { code: code } });
},

    goDetail(val){
      var url = '#/cari/duzenle/' + val.replace('/', '%2f');
      window.location.href = url;
      console.log(url);
    },
    Raporla: Raporla,
  },
  beforeMount: beforeMount,
  components: {
    tarihim,
    yetkidialog,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.load = true;
      this.load1 = false;

      // this.date = helpers.getDateNow();
      // this.date2 =helpers.getDateNow();

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var getCurrentInput = {
        Code: this.$route.params.id,
        CompanyCode: credentials.SirketKodu,
        SummaryInfoShow: true,
      };
      this.$http
        .post(auth.API_URL + "api/Current/Get", getCurrentInput, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.Toplambiletadet = response.body.SummaryInfo.SalesNumber;
            this.Faturaedilmemisbilet =
              response.body.SummaryInfo.NoInvoiceTicketNumber;
            this.Toplamfatbiletad =
              response.body.SummaryInfo.InvoiceTicketNumber;
            this.Current = response.body;

            this.load = false;
            this.load1 = true;
          },
          (response) => {
            if (response.status === 0) {
              this.load = false;
              this.load1 = true;
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.load = false;
              this.load1 = true;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
};

function beforeMount() {}

function Raporla() {
  this.load1 = false;

  this.$validator.validateAll().then((result) => {
    if (result) {
      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
        var credentials1 = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        var params = {
          SirketKodu: credentials1.SirketKodu,
          BaslangicTarihi: new Date(this.date),
          BitisTarihi: new Date(this.date2),
          CariKod: this.Current.Code,
        };

        this.$http
          .post(auth.API_URL + "api/TicketReport/SummaryInfoList", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              this.load1 = true;

              this.Toplambiletadet = response.body.SatisAdet;
              this.Faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
              this.Toplamfatbiletad = response.body.FaturalanmisBiletAdet;
            },
            (response) => {
              this.load1 = true;

              if (response.status === 0) {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
              } else {
                this.load1 = true;

                this.text1 = "Service Unavailable";
                this.snackbar = true;
              }
            }
          );
      } else {
        this.load1 = true;

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  });
}
</script>

<style>
</style>




<!-- <template>
  <v-card color="grey lighten-5" flat>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-flex xs12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="white--text"
          > {{ $t('Current-Card-Details') }} </v-toolbar-title
        >
        <v-spacer></v-spacer>

    
          <v-btn class="white--text" @click="goDetail(Current.Code)" flat>
            <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
            <v-icon right dark>create</v-icon>
          </v-btn>
      </v-toolbar>
    </v-flex>

    <v-layout row wrap>
      <v-flex pa-1 xs12 sm12 md6>
        <v-flex xs12 sm12 md12 style="padding-right: 2px">
          <v-card color="#1E88E5" class="white--text">
            <v-layout>
              <v-flex xs2 sm2 md1>
                <v-layout align-center="" justify-center="" fill-height="">
                  <v-icon color="white" large="">perm_identity</v-icon>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm10 md11>
                <v-card-title primary-title="">
                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            {{ $t("Title_label") }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Title }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Code') }} </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Code }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t("Authorized_label") }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Authorized }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Identitynumber_label') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.IdentityNumber }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md2>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{$t('Taxcenter_label') }} / {{ $t('No') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md10>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.TaxOffice }}/{{
                                Current.Invoice.TaxNumber
                              }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
              {{ $t('General-Information') }}
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-flex>

      <v-flex pa-1 xs12 sm12 md6>
        <v-flex xs12 sm12 md12 style="padding-right: 2px">
          <v-card color="#1E88E5" class="white--text">
            <v-layout>
              <v-flex xs2 sm2 md1>
                <v-layout align-center="" justify-center="" fill-height="">
                  <v-icon color="white" large="">info</v-icon>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm10 md11>
                <v-card-title primary-title="">
                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Phonenumber_label') }} 1 </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Phone1 }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold"> {{ $t('Phonenumber_label') }} 2 </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            : {{ Current.Phone2 }}
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              Web
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md5>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Web }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Email_label') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md5>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Email }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>


                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t("Address_label") }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.Address }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm3 md1>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              {{ $t('Expense-Unit-VKN') }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                      <v-flex xs12 sm9 md11>
                        <v-list-tile-title>
                          <span class="caption font-weight-bold">
                            <div
                              class="font-weight-bold caption white--text mb-1"
                            >
                              : {{ Current.Invoice.SpendingUnitVKN }}
                            </div>
                          </span>
                        </v-list-tile-title>
                      </v-flex>
                    </v-layout>
                  </v-flex>

              
                </v-card-title>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
              {{ $t('Contact-Information') }}
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-card color="grey lighten-5" flat="">
      <v-layout row wrap>
        <v-flex xs12 pt-2 pb-2 pr-1 pl-1 sm12 md12>
          <v-card flat>
            <v-layout pa-2 row wrap>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="false"
                  v-model="date"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                ></tarihim>
              </v-flex>

              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="date2"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                ></tarihim>
              </v-flex>

              <v-flex align-end="" xs12 sm1 md1>
                <div v-if="load1">
                  <v-btn color="info" @click="Raporla()" fab small="" dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>

                <div v-if="!load1">
                  <v-progress-circular
                    indeterminate
                    :width="4"
                    color="blue"
                  ></v-progress-circular>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-layout row="" wrap>
          <v-flex pa-1 xs12 sm6 md4>
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">add_comment</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Toplambiletadet }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold">
                  {{  $t('Total-Ticket-Number') }}
                </span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#4CAF50" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Toplamfatbiletad }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold"
                  >{{ $t('Invoiced-Ticket-Number') }}</span
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#FF5252" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{ Faturaedilmemisbilet }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold">
                  {{ $t('Not-invoiced-Ticket-Number') }}</span
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </v-card>
</template>


<script>
import auth from "../../../api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },

      prevRoute: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      modal2: false,
      dateFormatted2: "",
      Current: {
        CompanyCode: "",
        Code: "",
        Title: "",
        Phone1: "",
        Phone2: "",
        Mobile: "",
        Web: "",
        Authorized: "",
        WarningNote: "",
        InfoNote: "",
        Invoice: {
          Address: "",
          PostCode: "",
          Province: "",
          Country: "",
          TaxNumber: "",
          TaxOffice: "",
          IdentityNumber: "",
        },
      },
      StartDate: null,
      EndDate: null,
      Faturaedilmemisbilet: 0,
      Toplamfatbiletad: 0,
      Toplambiletadet: 0,
      load: false,
      load1: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",

      dictionary: {
        custom: {
          tarihsecbas: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsecbit: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  methods: {
    goDetail(val){
      var url = '#/cari/duzenle/' + val.replace('/', '%2f');
      window.location.href = url;
    },
    Raporla: Raporla,
  },
  beforeMount: beforeMount,
  components: {
    tarihim,
    yetkidialog,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.load = true;
      this.load1 = false;

      // this.date = helpers.getDateNow();
      // this.date2 =helpers.getDateNow();

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var getCurrentInput = {
        Code: this.$route.params.id,
        CompanyCode: credentials.SirketKodu,
        SummaryInfoShow: true,
      };
      this.$http
        .post(auth.API_URL + "api/Current/Get", getCurrentInput, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.Toplambiletadet = response.body.SummaryInfo.SalesNumber;
            this.Faturaedilmemisbilet =
              response.body.SummaryInfo.NoInvoiceTicketNumber;
            this.Toplamfatbiletad =
              response.body.SummaryInfo.InvoiceTicketNumber;
            this.Current = response.body;

            this.load = false;
            this.load1 = true;
          },
          (response) => {
            if (response.status === 0) {
              this.load = false;
              this.load1 = true;
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.load = false;
              this.load1 = true;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
};

function beforeMount() {}

function Raporla() {
  this.load1 = false;

  this.$validator.validateAll().then((result) => {
    if (result) {
      var bastarih = new Date(this.date);
      var bittarih = new Date(this.date2);

      if (bastarih <= bittarih) {
        var credentials1 = JSON.parse(
          window.localStorage.getItem("credentials")
        );

        var params = {
          SirketKodu: credentials1.SirketKodu,
          BaslangicTarihi: new Date(this.date),
          BitisTarihi: new Date(this.date2),
          CariKod: this.Current.Code,
        };

        this.$http
          .post(auth.API_URL + "api/TicketReport/SummaryInfoList", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              this.load1 = true;

              this.Toplambiletadet = response.body.SatisAdet;
              this.Faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
              this.Toplamfatbiletad = response.body.FaturalanmisBiletAdet;
            },
            (response) => {
              this.load1 = true;

              if (response.status === 0) {
                this.text1 = "Service Unavailable";
                this.snackbar = true;
              } else {
                this.load1 = true;

                this.text1 = "Service Unavailable";
                this.snackbar = true;
              }
            }
          );
      } else {
        this.load1 = true;

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  });
}
</script>

<style>
</style> -->